import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { I18nService } from '../shared/i18n/i18n.service';

export const FRONTEND_LANGUAGE_HEADER = 'frontend-language';

/**
 * Attaches the current UI language as a `frontend-language` header on every
 * outgoing HTTP request. The backend reads this header to return translated
 * error messages in the correct language without any per-call wiring. The language
 * used here is the same as the one returned by `i18n.lang()`; LanguageType
 */
export const langHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const i18n = inject(I18nService);
  const cloned = req.clone({
    setHeaders: { [FRONTEND_LANGUAGE_HEADER]: i18n.lang() },
  });
  return next(cloned);
};
